module.exports = __webpack_public_path__ + "static/icon-nasa-427a2c545879717551810e670d8bc731.png";